import { getTTFB } from 'web-vitals/base';

const onTimeToFirstByte = response => {
  getTTFB(ttfb => response(ttfb.value));
};

export default onTimeToFirstByte;
